import { AnalyticsDashboardAppConfig } from "./dashboards/analytics/AnalyticsDashboardAppConfig";
import { ProjectDashboardAppConfig } from "./dashboards/project/ProjectDashboardAppConfig";
import { MailAppConfig } from "./mail/MailAppConfig";
import { TodoAppConfig } from "./todo/TodoAppConfig";
import { ContactsAppConfig } from "./contacts/ContactsAppConfig";
import { FileManagerAppConfig } from "./file-manager/FileManagerAppConfig";
import { CalendarAppConfig } from "./calendar/CalendarAppConfig";
import { ChatAppConfig } from "./chat/ChatAppConfig";
import { ECommerceAppConfig } from "./e-commerce/ECommerceAppConfig";
import { ScrumboardAppConfig } from "./scrumboard/ScrumboardAppConfig";
import { AcademyAppConfig } from "./academy/AcademyAppConfig";
import { NotesAppConfig } from "./notes/NotesAppConfig";
import { DocRouteAuthConfig, DocRouteConfig } from "app/Doc/DocRouteConfig";

export const appsConfigs = [
	AnalyticsDashboardAppConfig,
	ProjectDashboardAppConfig,
	MailAppConfig,
	TodoAppConfig,
	FileManagerAppConfig,
	ContactsAppConfig,
	CalendarAppConfig,
	ChatAppConfig,
	ECommerceAppConfig,
	DocRouteConfig,
	DocRouteAuthConfig,
	ScrumboardAppConfig,
	AcademyAppConfig,
	NotesAppConfig,
];
